import { render, staticRenderFns } from "./ShowSalesMaterial.vue?vue&type=template&id=f75db4a8&scoped=true"
import script from "./ShowSalesMaterial.vue?vue&type=script&lang=js"
export * from "./ShowSalesMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75db4a8",
  null
  
)

export default component.exports